// Module
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MatchingRoutingModule } from './matching-routing.module';
// Component
import { MatchingAutoComponent } from './auto/auto.component';
import { MatchingProjectListComponent } from './project/list/list.component';
import { MatchingProjectDetailComponent } from './project/detail/detail.component';
import { MatchingWorkerListComponent } from './worker/list/list.component';
import { MatchingWorkerDetailComponent } from './worker/detail/detail.component';
import { CoreModule } from 'src/app/core/core.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgxPaginationModule } from 'ngx-pagination';

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthorizationInterceptor } from 'src/app/shared/interceptor/authorization.interceptor';
import { OverviewListComponent } from './overview-list/overview-list.component';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    SharedModule,
    MatchingRoutingModule,
    NgbModule.forRoot(),
    NgxPaginationModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthorizationInterceptor,
      multi: true
    }
  ],
  declarations: [
    MatchingAutoComponent,
    MatchingProjectListComponent,
    MatchingProjectDetailComponent,
    MatchingWorkerListComponent,
    MatchingWorkerDetailComponent,
    OverviewListComponent
  ]
})
export class MatchingModule {}
